import { Box, Flex, FloraTypography, ScrollArea, useIsMobile } from '@grupoboticario/flora-react'
import { ProductItem } from '@grupoboticario/tag-book-sellout'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSwipeable } from 'react-swipeable'
import { VideoShowcase } from 'src/@interfaces'
import { useCycle, useResellerContext, useVideoShowcase } from 'src/hooks'
import {
  trackCloseVideo,
  trackProductList,
  trackSeeDetails,
  trackSwipeBack,
  trackSwipeNext,
  trackVideoClick,
  trackVolume,
} from './Video.analytics'
import { VideoCard } from './VideoCard'
import { VideoModal } from './VideoModal'
import { VideoScrollAreaSkeleton } from './VideoScrollAreaSkeleton'

export const VideoScrollArea = () => {
  const { cycle } = useCycle()
  const navigate = useNavigate()
  const resellerContext = useResellerContext()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState<VideoShowcase>()
  const { videoList, isLoading } = useVideoShowcase()
  const isEmpty = videoList.length === 0 && !isLoading
  const isMobile = useIsMobile()
  const currentCycle = cycle?.id || ''

  const toggleIsModalOpen = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleVideoClick = (video: VideoShowcase) => {
    setSelectedVideo(video)
    trackVideoClick({ productSku: video.sku, cycle: currentCycle })
    toggleIsModalOpen()
  }

  const closeModal = () => {
    trackCloseVideo({ productSku: selectedVideo?.sku!, cycle: currentCycle })
    toggleIsModalOpen()
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      trackSwipeNext({ cycle: currentCycle })
    },
    onSwipedRight: () => {
      trackSwipeBack({ cycle: currentCycle })
    },
  })

  const handleProductDetailButtonClick = (productSku: string) => {
    trackSeeDetails({ productSku, cycle: currentCycle })
    navigate(`/${resellerContext?.reseller?.catalogSlug}/produto/${productSku}`)
  }

  const handleVideoMutedChange = (muted: boolean, currentVideo: VideoShowcase) => {
    trackVolume({ productSku: currentVideo.sku, muted: !muted, cycle: currentCycle })
  }

  useEffect(() => {
    const productList = videoList.map(({ sku, name }) => {
      return { sku, name } as Partial<ProductItem>
    })

    trackProductList({ skuList: productList })
  }, [])

  if (isLoading) {
    return <VideoScrollAreaSkeleton />
  }

  if (isEmpty) {
    return null
  }

  return (
    <Box css={{ paddingTop: '$4' }}>
      <FloraTypography
        fontWeight="regular"
        fontSize="subtitle"
        viewport={isMobile ? 'mobile' : 'desktop'}
        css={{ marginBottom: '$2' }}
      >
        Vídeos em destaque
      </FloraTypography>
      <ScrollArea
        orientation="horizontal"
        css={{ '[data-orientation=horizontal]': { display: 'none' } }}
      >
        <Flex
          gap="$4"
          {...swipeHandlers}
        >
          {videoList.map((video) => (
            <VideoCard
              video={video}
              onClick={() => handleVideoClick(video)}
              key={video.sku}
            />
          ))}
        </Flex>
        {isModalOpen && selectedVideo ? (
          <VideoModal
            video={selectedVideo}
            closeModal={closeModal}
            onClickProductDetails={handleProductDetailButtonClick}
            onMuted={handleVideoMutedChange}
          />
        ) : null}
      </ScrollArea>
    </Box>
  )
}
